import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/styles';
import { get } from 'lodash';
import styles from './styles';
import { GenericFormFields } from '../interfaces';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { cyrb53Hash } from 'utils/helpers';

const useStyles = makeStyles(styles);

const FormSelect: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  const classes = useStyles({ fontSize: item.fontSize });

  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel?.current?.offsetWidth ?? 200);
  }, []);

  const showError = () => {
    if (!!get(errors, item.error, null) && !item.disabled)
      return <FormHelperText>{get(errors, item.error, null)}</FormHelperText>;
    if (!!get(errors, item.stateKey, null) && !item.disabled)
      return (
        <FormHelperText>{get(errors, item.stateKey, null)}</FormHelperText>
      );
    return null;
  };

  const handleChange = (e: React.ChangeEvent<{ value: any }>) => {
    if (setFieldValue)
      setFieldValue(
        item.stateKey,
        item.multipleSelect ? (e.target.value as string[]) : e.target.value
      );
    if (changeField)
      changeField({
        key: item.stateKey,
        value: item.multipleSelect
          ? (e.target.value as string[])
          : e.target.value,
      });
  };

  return (
    <FormControl
      variant="outlined"
      fullWidth
      error={
        !item.disabled &&
        (!!get(errors, item.stateKey, null) || !!get(errors, item.error, null))
      }
    >
      <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
        {item.label}
      </InputLabel>
      <Select
        multiple={item.multipleSelect}
        native={!item.multipleSelect}
        labelId="demo-simple-select-outlined-label"
        key={item.stateKey}
        name={item.stateKey}
        value={
          fields
            ? get(fields, item.stateKey, '')
            : get(values, item.stateKey, '')
        }
        renderValue={
          item.multipleSelect
            ? selected => (selected as string[]).join(', ')
            : undefined
        }
        onChange={handleChange}
        labelWidth={labelWidth}
        disabled={item.disabled}
      >
        {item.multipleSelect ? (
          item?.options?.map(child => (
            <MenuItem key={cyrb53Hash(child.label)} value={child.value}>
              <Checkbox
                checked={
                  fields
                    ? get(fields, item.stateKey, '').indexOf(child.value) > -1
                    : get(values, item.stateKey, '').indexOf(child.value) > -1
                }
              />
              <ListItemText primary={child.label} />
            </MenuItem>
          ))
        ) : (
          <React.Fragment>
            {!item.selectCantBeNull && <option value="" />}
            {item?.options?.map(child => (
              <option
                key={cyrb53Hash(child.label)}
                className={classes.selectLabel}
                value={child.value}
              >
                {child.label}
              </option>
            ))}
          </React.Fragment>
        )}
      </Select>
      {showError()}
    </FormControl>
  );
};

export default FormSelect;
